export default "__VITE_ASSET__DltRRVcm__"